import React, { ReactNode, memo, useEffect } from "react";
import { isNil } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import Layout from "../../Layout";
import { ApplicationState } from "../../../store";
import { Data } from "../../../store/receipt/types";
import { fetchRequest as fetchReceipt } from "../../../store/receipt/actions";
import { fetchRequest as fetchCardTypes } from "../../../store/cardType/actions";
import Alert from "@mui/lab/Alert";
import ReceiptEditForm from "../receiptEditForm/ReceiptEditForm";
import useSession from "../../../effects/useSession";
import pageStyles from "../../pageStyles";
import PageHeading from "../../../common/pageHeading/PageHeading";
import { getById } from "../../../store/receipt/queries";
import ProgressIndicator from "../../../common/progressIndicator/ProgressIndicator";
import { get } from "lodash";

const CREATE = "CREATE";
const UPDATE = "UPDATE";

const SaveError: React.FC<{ children: ReactNode }> = ({ children }) => (
  <Alert severity="error">{children}</Alert>
);

function ReceiptEdit() {
  const dispatch = useDispatch();
  const session = useSession();
  const classes = pageStyles();
  const { id } = useParams<{ id: string }>();

  const mode = id ? UPDATE : CREATE;

  const ReceiptState = useSelector((state: ApplicationState) => state.receipt);

  useEffect(() => {
    !isNil(id) && dispatch(fetchReceipt(id));
    dispatch(fetchCardTypes(null));
  }, []);

  const receiptData = useSelector(id ? getById(id) : () => null) as Data;
  if (
    receiptData &&
    receiptData.attributes &&
    !Array.isArray(receiptData?.attributes?.CardType)
  ) {
    receiptData.attributes.CardType = [];
  }
  const cardTypeState = useSelector(
    (state: ApplicationState) => state.cardType?.data?.data ?? []
  );
  const listCardType = get(cardTypeState, "0.CardTypes", []);

  const headingText = () => {
    return mode === CREATE ? "New Receipt" : "Edit Receipt";
  };
  const isCreate = Boolean(mode === CREATE)

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading={headingText()} />
              </Paper>
            </Grid>
            <Grid xs={12}>
              <Paper className={classes.paper}>
                <ReceiptEditForm
                  cardTypes={listCardType}
                  receiptData={receiptData}
                  isCreate={isCreate}
                />
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}

export default memo(ReceiptEdit);
